<!-- Catalognotfound is an independendent Page with its own Header and Footer -->
@if (
	(validCatalog && catalogIntegrationType === CatalogIntegrationType.None) ||
	catalogIntegrationType === CatalogIntegrationType.CatalogViewer
) {
	<!-- CataloPending is an independendent Page with its own Header and Footer -->
	<!-- TODO: *ngIf="catalog?.catalogState !== catalogStatePendingPublish; else catalogPending" bei <app-responsive-desktop-container> wieder einfügen, wenn Bug 10535 gefixt ist -->
	<app-responsive-desktop-container class="h-100">
		@if (catalog !== null) {
			<div class="d-flex flex-column h-100" appContextMenuClose id="catalogwrapper">
				<div class="flex-grow-1">
					<app-header
						[catalogKey]="catalogKey"
						[showInfoletter]="true"
						[showWatchlist]="true"
						[showInternalWatchlist]="true"
						[catalogIntegrationType]="catalogIntegrationType"
						[integrationSettings]="integrationSettings">
					</app-header>
				</div>
				<main class="h-100 w-100 d-flex overflow-hidden">
					@if (catalog) {
						<ng-container class="h-100">
							<div class="h-100 pe-0 min-view-width overflow-y-auto position-relative vw-100">
								<div
									class="h-100 w-100 grid-desktop-container-navigation min-height"
									[class.minimized-details]="minimizedDetails">
									<div class="grid-filter-tree h-100 overflow-hidden">
										<app-catalog-desktop-navigation
											[minimizedFilter]="minimizedFilter"
											[canNavigateToStartingPage]="integrationSettings?.canNavigateToStartingPage"
											[breadcrumbs]="breadcrumbs"
											[catalog]="catalog"
											[hasTree]="hasTree"
											[currentQueryParams]="catalogQueryParams"
											[currentRoutingParams]="catalogRoutingParams"
											[catalogSearchResultModel]="catalogSearchResultModel"
											[defaultTags]="defaultTags"
											[selectedTags]="selectedTags"
											[tags]="tags"
											[categoryGroups]="categoryGroups"
											[catalogHeaderSelected]="catalogHeaderSelected"
											[rootLink]="getRootLink()"
											[categoryTooltip]="categoryTooltip"
											[categoriesText]="categoriesText"
											[languageCatalogs]="languageCatalogs"
											[relatedCatalogs]="relatedCatalogs"
											[categoryTooltip]="categoryTooltip"
											(emptySearch)="clearSearch()"
											(openNews)="openNews($event)"></app-catalog-desktop-navigation>
									</div>
									<div id="mainContent" class="grid-details border-2 overflow-hidden bg-gray-100 position-relative">
										<div class="position-absolute toggle-details-button zindex-sticky">
											<div
												class="position-fixed cursor-pointer bg-gray-400 rounded d-flex align-items-center justify-content-center toggle-button-size"
												(click)="toggleDetailsSize()">
												<div
													class="mask-settings bg-dark grid-mask-img d-inline-block"
													[ngClass]="
														minimizedDetails
															? 'navigate-before-mask-img position-relative'
															: 'navigate-next-mask-img'
													"></div>
											</div>
										</div>
										<div class="h-100 min-height">
											<!-- CatalogDetail -->
											<app-catalog-details
												#catalogDetails
												id="detailview"
												[catalogDetailsType]="catalogDetailsType"
												[catalogViewForeignLanguageCatalogsDto]="languageCatalogs"
												[hasContactPersons]="catalog?.hasContactPersons"
												[catalogViewRelatedCatalogsDto]="relatedCatalogs"
												[nodeTitle]="catalog?.title"
												[queryParams]="catalogQueryParams"
												[routingParams]="catalogRoutingParams"
												(contactFormOpen)="openContactForm($event)"
												[url]="url"
												[exportSettings]="catalog.exportSettings"
												[catalogTitle]="catalog?.title"
												[catalogKey]="catalogKey"
												[featureToggles]="featureToggles"
												[integrationSettings]="integrationSettings"
												[catalogIntegrationType]="catalogIntegrationType"
												[catalogViewShowPrice]="catalog.catalogViewShowPrice"
												[catalogLanguage]="catalog.language"
												(minimize)="toggleDetailsSize()"
												[minimized]="minimizedDetails">
											</app-catalog-details>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					} @else {
						@if (validCatalog) {
							<lib-loading class="w-100"> </lib-loading>
						}
					}
				</main>
				@if (!isInIntegrationMode) {
					<div class="flex-grow-1">
						<app-footer [toggleButtonPositionRight]="5"></app-footer>
					</div>
				}
			</div>
		}
		<!-- TODO: diese Überprüfung muss auf eine andere Variable gehen und NICHT auf catalogStatePendingPublish, eine die erst angelegt werden muss (Backend und Frontend) Die Variable schaut, ob gerade der Freigabe-Vorgang aktiv ist, dann wird dieses HTML angezeigt! -->
		<!--<div *ngIf="catalog?.catalogState === catalogStatePendingPublish">
    <app-catalog-pending></app-catalog-pending>
  </div>-->
	</app-responsive-desktop-container>
}
@if (!validCatalog) {
	@defer {
		<app-catalog-not-found></app-catalog-not-found>
	}
}
@if (!IsNullish(catalog) && catalogIntegrationType === CatalogIntegrationType.CatalogItemViewer) {
	@if (catalog !== null) {
		<div class="h-100" style="align-items: stretch" appContextMenuClose>
			<app-catalog-details
				#catalogDetails
				[catalogDetailsType]="catalogDetailsType"
				[queryParams]="catalogQueryParams"
				[catalogIntegrationType]="catalogIntegrationType"
				[integrationSettings]="integrationSettings"
				[routingParams]="catalogRoutingParams"
				(contactFormOpen)="openContactForm($event)"
				[url]="url"
				[catalogKey]="catalogKey"
				[exportSettings]="catalog.exportSettings"
				[featureToggles]="featureToggles"
				[catalogLanguage]="catalog.language">
				<app-header
					[catalogKey]="catalogKey"
					[catalogIntegrationType]="catalogIntegrationType"
					[integrationSettings]="integrationSettings">
				</app-header>
			</app-catalog-details>
		</div>
	}
}
